import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box, Select,
  FormControl, InputLabel,MenuItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Swal from "sweetalert2";
import { useAuth } from "../../../../AuthProvider";


import { ListItemIcon, Menu,ListItemText} from "@mui/material"; 
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';

function StudentBusReports() {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [busNumber, setbusNumber] = useState([]);
  const [selectedBus, setSelectedBus] = useState("");
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading
  


  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();
  const { oId,userId,role,pId } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
        const isExportMenuOpen = Boolean(exportAnchorEl);
        
        const handleExportClick = (event) => {
          setExportAnchorEl(event.currentTarget);
        };
        
        const handleExportClose = () => {
          setExportAnchorEl(null);
        };
  

  const handleAddNew = () => {
    navigate("/BusFeeRegistrationForm");
  };

   const [adminusers, setadminUsers] = useState([]);
    const [selectedadminUsers, setSelectedadminUsers] = useState("");
  
    console.log("Selected admin:",selectedadminUsers);
  
     useEffect(() => {
      const fetchUsers = async () => {
          try {
              const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
              if (!response.ok) {
                  throw new Error('Failed to fetch users');
              }
              const data = await response.json();
              setadminUsers(data);
              if (data.length > 0) {
                setSelectedadminUsers(data[0].userId); // ✅ Set first record's userId as default
            }
          } catch (error) {
              console.error('Error fetching users:', error);
          }
      };
 
  
      fetchUsers();
    
  }, []);



  const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;
    
   
      const fetchUsers = async () => {
          try {
              const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
              if (!response.ok) {
                  throw new Error('Failed to fetch users');
              }
              const data = await response.json();
              setUsers(data);
              if (data.length > 0) {
                setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
            }
          } catch (error) {
              console.error('Error fetching users:', error);
          }
      };

    useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);



  useEffect(() => {
    const fetchData = async () => {
      if(!UserId) return;
      try {
        const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${oId}/${UserId}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setbusNumber(data); // Assuming 'data' is an array of bus numbers
        setSelectedBus(data[0]);
       
      } catch (error) {
        
        console.error("Error fetching Bus Numbers:", error);
      } 
    };

    fetchData();
  }, [UserId]);

 
    const fetchData = async () => {
      if (!selectedBus) {
        setLoading(false); // Ensure loading state is removed if no bus is selected
        return; 
      }
      setLoading(true);
      try {
        const response = await fetch(`${baseUrl}/api/reports/bus/getAll/${oId}/${pId}`);
        const data = await response.json();
        console.log("API Response:", data);

       // If response is not ok or data is not an array/object as expected
        if (!response.ok || !data || data.length === 0) {
          setFilteredData([]); // Clear the list on empty response
        } else {
          setFilteredData(data);
        }

      } catch (error) {
        setFilteredData([]);
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
   
      fetchData();
 
  }, [selectedBus,oId]);


  // Filter data based on searchQuery
// const filteredResults = filteredData.filter((item) => {
//   const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
//   const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
//   const fullName = `${studentFirstName} ${studentLastName}`; // Combine first and last names
//   return fullName.includes(searchQuery.toLowerCase()); // Search in full name
// });

const filteredResults = filteredData.filter((item) => {
  const studentFirstName = item.studentFirstName?.toLowerCase() || "";
  const studentLastName = item.studentLastName?.toLowerCase() || "";
  const fullName = `${studentFirstName} ${studentLastName}`;
  return fullName.includes(searchQuery?.toLowerCase() || "");
});



// Filter data based on bus selection
// useEffect(() => {
//   const filteredByBus = selectedBus
//     ? filteredData.filter((entry) => entry.busNumber.toString() === selectedBus.toString())
//     : filteredData;

//     setFilteredData([...filteredByBus]);  // ✅ Triggers re-render
// }, [selectedBus, filteredData, setFilteredData]);






  const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };

   const handleSaveChanges = async () => {
   
     console.log("Selected Row Data before update:", selectedRow);
     setDialogbtnloading(true); // Start loading
     try {
       const formData = new FormData();
   
       // Append each key-value pair to FormData
       Object.keys(selectedRow).forEach((key) => {
         if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
           formData.append(key, selectedRow[key]);
         }
       });
   
       // Use `selectedRow.id` instead of `rowId`
       const response = await fetch(
         `${baseUrl}/api/StudentBusList/update/${selectedRow.id}/${oId}`,
         {
           method: "PATCH",
           body: formData,
         }
       );
   
       const responseData = await response.json();
   
       if (!response.ok) {
         throw new Error(responseData.message || "Failed to update the details.");
       }
   
       toast.success("Student Bus Details updated successfully!");
       fetchData();
       // Refresh the data list
       setFilteredData((prevData) =>
         prevData.map((driver) =>
           driver.id === selectedRow.id ? { ...driver, ...selectedRow } : driver
         )
       );
   
       handleDialogClose();
     } catch (error) {
       console.error("Error updating details:", error);
       toast.error(`Error updating details: ${error.message}`);
     }finally {
      setDialogbtnloading(false); // Stop loading
    }
   };



  const handleDeleteClick = async (row) => {
    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }
  
    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You Want To Delete ${row.studentFirstName} ${row.studentLastName} From the ${row.busNumber}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);
          const response = await fetch(
            `${baseUrl}/api/StudentBusList/delete/${row.id}/${oId}`,
            {
              method: "DELETE",
            }
          );
  
          if (!response.ok) {
            throw new Error("Failed to delete the row. Please try again.");
          }
  
          toast.success(`Student deleted from ${row.busNumber} successfully!` , {
            autoClose: 2000, // Closes after 1 second (1000ms)
          });
          
          fetchData();
         
  
         
        } catch (error) {
          console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  const dataCellStyle = { 
    textAlign: "center", 
    borderRight: "1px solid #ddd", 
    padding: "2px" 
  };
    
     // Export to Excel
     const exportToExcel = () => {
     const filteredData = filteredResults.map(
  ({
    busNumber,
    busNumberPlate,
    driverName,
    driverNumber,
    routeNumber,
    attenderName,
    attenderNumber,
    busStudentCount,
  }) => ({
    // BusNumber: busNumber || "NA",
    BusNumberPlate: busNumberPlate || "NA",
    DriverName: driverName || "NA",
    DriverNumber: driverNumber || "NA",
    RouteVia: routeNumber || "NA",
    AttenderName: attenderName?.trim() ? attenderName : "NA",
    Attendernumber: attenderNumber?.trim() ? attenderNumber : "NA",
    StudentCount: busStudentCount !== undefined && busStudentCount !== null ? busStudentCount : "NA",
  })
);

    
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(`Bus_Reports`);
    
      // Add headers
      worksheet.columns = [
        // { header: "Student Name", key: "Name", width: 20 },
        // { header: "Gender", key: "Gender", width: 10 },
        // { header: "Bus No", key: "BusNumber", width: 20 },
        { header: "Bus NumberPlate", key: "BusNumberPlate", width: 20 },
        { header: "Driver Name", key: "DriverName", width: 15 },
        { header: "Driver Number", key: "DriverNumber", width: 15 },
        { header: "Route Via", key: "RouteVia", width: 20 },
        { header: "Attender Name", key: "AttenderName", width: 20 },
        { header: "Attender number", key: "Attendernumber", width: 20 },
        { header: "Student Count", key: "StudentCount", width: 20 },
      ];
    
      // Add data rows
      filteredData.forEach((data) => {
        worksheet.addRow(data);
      });
    
      // Style headers
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "87CEEB" }, // Light Blue Header
        };
      });
    
      // Write and download file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Bus_Reports.xlsx`;
        link.click();
      });
    
      handleExportClose();
    };
    
     
     // Export to PDF
    const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Bus Report", 10, 10);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 18);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 42, 18);

  // Processed data with "NA" handling like Excel
  const processedData = filteredResults.map((row, index) => [
    index + 1,
    // row.busNumber || "NA",
    row.busNumberPlate?.trim() ? row.busNumberPlate : "NA",
    row.driverName || "NA",
    row.driverNumber || "NA",
    row.routeNumber || "NA",
    row.attenderName?.trim() ? row.attenderName : "NA",
    row.attenderNumber?.trim() ? row.attenderNumber : "NA",
    row.busStudentCount !== undefined && row.busStudentCount !== null ? row.busStudentCount : "NA",
  ]);

  // Table
  doc.autoTable({
    startY: 25,
    head: [
      [
        "S.No",
        // "Bus No",
        "Bus Number Plate",
        "Driver Name",
        "Driver Number",
        "Route Via",
        "Attender Name",
        "Attender Number",
        "Student Count",
      ],
    ],
    body: processedData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
      fontSize: 9,
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  doc.save("Bus_Reports.pdf");
  handleExportClose();
};

    
     
     
     // Export to JSON
     const exportToJSON = () => {
       const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
         JSON.stringify(filteredResults, null, 2)
       )}`;
       const link = document.createElement("a");
       link.href = jsonString;
       link.download = `${selectedBus}_Students_List.json`;
       link.click();
       handleExportClose();
     };
  
  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent >
        
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Bus Reports
                              </Typography>
                            </Box>

        {/* Search and Add New Button Section */}
       <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  spacing={2}
  style={{ marginTop: "8px", flexWrap: "nowrap" }}
>
  {/* Left Side: Search + Selects */}
  <Grid item style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
    {/* Search by Name */}
    <TextField
      label="Search by Name"
      variant="outlined"
      size="small"
      style={{ width: "150px" }}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />

    {/* Select Bus */}
    {/* <FormControl style={{ width: "150px" }} variant="outlined" size="small">
      <InputLabel id="bus-select-label" style={{ fontSize: "12px" }}>
        Select Bus
      </InputLabel>
      <Select
        labelId="bus-select-label"
        value={selectedBus}
        onChange={(e) => setSelectedBus(e.target.value)}
        label="Select Bus"
        style={{ height: "35px", fontSize: "13px" }}
      >
        {busNumber.map((bus, index) => (
          <MenuItem key={index} value={bus}>
            {bus}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}

    {/* Select Admin */}
    {/* <FormControl style={{ width: "150px" }} variant="outlined" size="small">
      <InputLabel>Select Admin</InputLabel>
      <Select
        value={selectedadminUsers}
        onChange={(e) => setSelectedadminUsers(e.target.value)}
        name="admStaffUserId"
        label="Select Admin"
      >
        {adminusers.map((user) => (
          <MenuItem key={user.userId} value={user.userId}>
            {user.userId} - {user.firstName} {user.lastName}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}

    {/* Select Transport Admin (if principal) */}
    {/* {isPrincipal && (
      <FormControl style={{ width: "150px" }} variant="outlined" size="small">
        <InputLabel>Select Transport Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Transport Admin"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )} */}
  </Grid>

  {/* Right Side: Export + Register Button */}
  <Grid
    item
    style={{ display: "flex", gap: "10px", justifyContent: "flex-end", flexWrap: "nowrap" }}
  >
    {/* Export Button with Menu */}
    <div>
      <Button
        variant="contained"
        onClick={handleExportClick}
        style={{ backgroundColor: "#3C3972", fontWeight: "bold", height: "40px" }}
        startIcon={<PresentToAllIcon />}
      >
        Export
      </Button>

      <Menu
        anchorEl={exportAnchorEl}
        open={isExportMenuOpen}
        onClose={handleExportClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          },
        }}
      >
        <MenuItem
          onClick={exportToExcel}
          sx={{ color: "#3f51b5", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f0fe" } }}
        >
          <ListItemIcon sx={{ color: "#00796b" }}>
            <SimCardDownloadIcon />
          </ListItemIcon>
          <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
        </MenuItem>

        <MenuItem
          onClick={exportToPDF}
          sx={{ color: "#d32f2f", fontWeight: "bold", "&:hover": { backgroundColor: "#fdecea" } }}
        >
          <ListItemIcon sx={{ color: "#d32f2f" }}>
            <PictureAsPdfIcon />
          </ListItemIcon>
          <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
        </MenuItem>

        {/* <MenuItem
          onClick={exportToJSON}
          sx={{ color: "#388e3c", fontWeight: "bold", "&:hover": { backgroundColor: "#e8f5e9" } }}
        >
          <ListItemIcon sx={{ color: "#6a1b9a" }}>
            <FilePresentIcon />
          </ListItemIcon>
          <ListItemText primary="JSON" sx={{ fontWeight: "bold", color: "#6a1b9a" }} />
        </MenuItem> */}
      </Menu>
    </div>

    {/* Register Button */}
    {/* <Button
      variant="contained"
      onClick={handleAddNew}
      style={{ backgroundColor: "#3C3972", fontWeight: "bold", height: "40px" }}
    >
      Register New Student
    </Button> */}
  </Grid>
</Grid>




<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>S.No</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Admission No</TableCell> */}
                 {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Bus No</TableCell> */}
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Bus NumberPlate</TableCell>
                   <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Driver Name</TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Driver Number</TableCell>
                     <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Route Via</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Student Name</TableCell> */}
             
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Gender</TableCell> */}
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Address</TableCell> */}
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Bus No</TableCell> */}
              
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}> Bus Total Fee</TableCell> */}
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Distance</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Pickup Location</TableCell>
                
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Father Name</TableCell> */}
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Father Email</TableCell> */}
                 <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Attender Name</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Attender number</TableCell>
                 <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Student Count</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Action</TableCell> */}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow 
  key={row.id} 
  style={{
    backgroundColor: "white",
    transition: "background-color 0.3s",
    height: "40px", // Reduced row height
  }}
  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"} // Hover color
  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"} // Default color
>
  <TableCell sx={dataCellStyle}>{index + 1}</TableCell>
  {/* <TableCell sx={dataCellStyle}>{row.customAdmissionNumber}</TableCell> */}
   {/* <TableCell sx={dataCellStyle}>{row.busNumber}</TableCell> */}

 <TableCell sx={dataCellStyle}>{row.busNumberPlate}</TableCell>
 <TableCell sx={dataCellStyle}>{row.driverName}</TableCell>
 <TableCell sx={dataCellStyle}>{row.driverNumber}</TableCell>

  {/* <TableCell sx={dataCellStyle}>{row.studentFirstName} {row.studentLastName}</TableCell> */}
  {/* <TableCell sx={dataCellStyle}>{row.gender}</TableCell> */}
  <TableCell sx={dataCellStyle}>{row.routeNumber}</TableCell>
  <TableCell sx={dataCellStyle}>{row.attenderName || "NA"}</TableCell>
  <TableCell sx={dataCellStyle}>{row.attenderNumber || "NA"}</TableCell>
  <TableCell sx={dataCellStyle}>{row.busStudentCount}</TableCell>
 
{/*  
  <TableCell sx={dataCellStyle}>₹{row.busTotalFee}</TableCell>
  <TableCell sx={dataCellStyle}>{row.distance}</TableCell>
  <TableCell sx={dataCellStyle}>{row.studentPickupLocation}</TableCell> */}
  
  {/* <TableCell sx={dataCellStyle}>{row.fatherName}</TableCell> */}
  {/* <TableCell sx={dataCellStyle}>{row.email}</TableCell> */}
  {/* <TableCell sx={dataCellStyle}>{row.fatherPhoneNumber}</TableCell> */}
  {/* <TableCell sx={{  borderRight: "1px solid #ddd",textAlign: "center", padding: "6px" }}>
    <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "4px",
                            }}
                          >

    <Button
                              sx={{
                                backgroundColor: "#1565c0",
                                color: "white",
                                "&:hover": { backgroundColor: "#0d47a1" },
                                // borderRadius: 2,
                                padding: "2px 4px",
                              }}
                              onClick={() => handleEditClick(row)}
                            >
                              Edit
                            </Button>
     <Button
                               sx={{
                                backgroundColor: "#a82814",
                                color: "white",
                                "&:hover": { backgroundColor: "#7a1b0e" },
                                // borderRadius: 2,
                                padding: "4px 6px",
                              }}
                              onClick={() => handleDeleteClick(row)}
                            >
                              Delete
                            </Button>
                            </Box>
  </TableCell> */}
  {/* <TableCell sx={{ borderRight: "1px solid #ddd", textAlign: "center", padding: "6px" }}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: "4px",
    }}
  >
    {/* Show Edit button only if student is NOT transferred */}
    {/* {row.studentBusStatus !== "newSchoolTransfer" && (
      <Button
        sx={{
          backgroundColor: "#1565c0",
          color: "white",
          "&:hover": { backgroundColor: "#0d47a1" },
          padding: "2px 4px",
        }}
        onClick={() => handleEditClick(row)}
      >
        Edit
      </Button>
    )} */}

    {/* Always show Delete button 
    <Button
      sx={{
        backgroundColor: "#a82814",
        color: "white",
        "&:hover": { backgroundColor: "#7a1b0e" },
        padding: "4px 6px",
      }}
      onClick={() => handleDeleteClick(row)}
    >
      Delete
    </Button>
  </Box>
</TableCell> */}




 <TableCell
              sx={{
                borderLeft: "1px solid #ddd",
                padding: "4px",
                textAlign: "center",
              }}
            >
              <Button
                type="button"
                // onClick={() => handleViewClick(row)} // Open dialog with the row data
              onClick={() => {
  // Save number plate in sessionStorage
  sessionStorage.setItem("busNumberPlate", row.busNumberPlate);

  // Navigate with only busNumber
  navigate(`/StudentsBusWiseReports/${row.busNumber}`);
}}

                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  fontSize: "0.6rem", // Reduces the font size
                  height: "25px", // Reduces the height
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                }}
              >
                View
              </Button>
            </TableCell> 


{/* <TableCell sx={{  padding: "4px", textAlign: "center" }}>
                      <Button
                        variant="contained"
                        color="success"
                        style={{
                         backgroundColor: row.studentBusStatus === "newSchoolTransfer" ? "#e53935" : "#65C63E", // red or green
                          color: "#fff",
                          fontWeight: "bold",
                          textTransform: "none",
                          borderRadius: "20px",
                        }}
                      >
                        {/* {row.studentBusStatus === "newSchoolTransfer" ? "Transferred" : "Present"} 
                      </Button>
                    </TableCell> */}




</TableRow>



                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog for editing */}
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
  <DialogTitle style={{ fontWeight: "bold"}}>Edit Student Bus Details</DialogTitle>
  <DialogContent>
    <Grid container spacing={2}>
      
      {/* Student Name */}
      <Grid item xs={6}>
        <TextField
          label="Student Name"
          value={
            selectedRow ? `${selectedRow.studentFirstName || ""} ${selectedRow.studentLastName || ""}` : ""
          }
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              studentFirstName: e.target.value.split(" ")[0] || "",
              studentLastName: e.target.value.split(" ")[1] || "",
            }))
          }
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
          }}
        />
      </Grid>

      {/* Gender */}
      <Grid item xs={6}>
        <TextField
          label="Gender"
          value={selectedRow?.gender || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              gender: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
          disabled
          InputProps={{
            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
          }}
        />
      </Grid>

      {/* Bus Number */}
      <Grid item xs={6}>
        <TextField
          label="Bus Number"
          value={selectedRow?.busNumber || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              busNumber: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>

      {/* Route Number */}
      <Grid item xs={6}>
        <TextField
          label="Route Number"
          value={selectedRow?.routeNumber || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              routeNumber: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>

      {/* Pickup Location */}
      <Grid item xs={6}>
        <TextField
          label="Pickup Location"
          value={selectedRow?.studentPickupLocation || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              studentPickupLocation: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          label="Father's Phone Number"
          value={selectedRow?.fatherPhoneNumber || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              fatherPhoneNumber: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>

      {/* Bus Total Fee */}
      <Grid item xs={6}>
        <TextField
          label="Bus Total Fee"
          value={selectedRow?.busTotalFee || ""}
          onChange={(e) =>
            setSelectedRow((prevState) => ({
              ...prevState,
              busTotalFee: e.target.value,
            }))
          }
          fullWidth
          margin="normal"
        />
      </Grid>
      
    </Grid>
  </DialogContent>

  {/* Dialog Actions */}
  <DialogActions>
       <Button
         onClick={handleDialogClose}
         color="primary"
         variant="outlined"
         
       >
         Cancel
       </Button>
       
       <Button
         onClick={handleSaveChanges}
         color="primary"
         variant="contained"
         disabled={dialogbtnloading} // Disable when loading
         sx={{
          fontWeight: 600,
          backgroundColor: "#3C3972",
          "&:hover": { backgroundColor: "#3C3972" },
        }}
       >
        {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
       </Button>
  </DialogActions>
</Dialog>
  <ToastContainer position="top-right" autoClose={2000}  />
      </CardContent>
    </Card>
  );
}

export default StudentBusReports;